(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var drawerReturnFocus = null;

  // Locale-aware root ('/', '/en/', '/de/') so section re-renders return the
  // current language instead of always falling back to the default (NL).
  function localeRoot() {
    var root = (window.casifyI18n && window.casifyI18n.localeRoot) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function openDrawer() {
    drawerReturnFocus = document.activeElement;
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    var firstClose = drawer.querySelector('.cart-drawer__close');
    if (firstClose) firstClose.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
    if (drawerReturnFocus && drawerReturnFocus.focus) drawerReturnFocus.focus();
    drawerReturnFocus = null;
  }

  async function refreshCart() {
    try {
      // no-store: avoid a cached section render that misses a just-applied
      // automatic discount (e.g. Assortion upsell discount).
      var res = await fetch(localeRoot() + '?section_id=cart-drawer', { cache: 'no-store' });
      if (!res.ok) return;
      var html = await res.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newBody = doc.getElementById('cart-drawer-body');
      var newFooter = doc.getElementById('cart-drawer-footer');
      var newTitle = doc.querySelector('.cart-drawer__title');

      if (newBody && document.getElementById('cart-drawer-body')) {
        document.getElementById('cart-drawer-body').innerHTML = newBody.innerHTML;
      }
      if (newFooter && document.getElementById('cart-drawer-footer')) {
        document.getElementById('cart-drawer-footer').innerHTML = newFooter.innerHTML;
      }
      if (newTitle && document.querySelector('.cart-drawer__title')) {
        document.querySelector('.cart-drawer__title').innerHTML = newTitle.innerHTML;
      }

      // Update header cart count badge
      updateCartCount();
    } catch (e) {}
  }

  async function updateCartCount() {
    try {
      var res = await fetch(localeRoot() + 'cart.js');
      if (!res.ok) return;
      var cart = await res.json();
      var badges = document.querySelectorAll('.site-header__cart-count, .mobile-sidebar__cart-count');
      badges.forEach(function (badge) {
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      });
    } catch (e) {}
  }

  // A discount/add-on injected by an app (Assortion) can land a short moment
  // after our own add-to-cart fires — sometimes later than a fixed delay.
  // Render immediately, then poll cart.js for a few seconds and re-render the
  // drawer whenever the total discount changes, so the applied upsell discount
  // shows up without the customer having to refresh the page.
  var settleTimers = [];
  function refreshCartUntilStable() {
    refreshCart();
    settleTimers.forEach(clearTimeout);
    settleTimers = [600, 1800, 3500].map(function (delay) {
      return setTimeout(refreshCart, delay);
    });
  }

  // Open from product page
  document.addEventListener('cart:open', function () {
    openDrawer();
    refreshCartUntilStable();
  });
  document.addEventListener('cart:updated', refreshCartUntilStable);

  // Public cart API for third-party apps (e.g. Assortion's discount engine
  // applies its bundle discount server-side a few seconds after add-to-cart
  // and needs a way to refresh our custom drawer when it's done).
  // Contract: any script may call CasifyCart.refresh() after mutating the
  // cart, or dispatch `document.dispatchEvent(new CustomEvent('cart:updated'))`.
  window.CasifyCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart,
    refreshUntilStable: refreshCartUntilStable,
  };

  // Close on overlay
  var overlay = document.getElementById('cart-drawer-overlay');
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Close button
  var closeBtn = drawer.querySelector('.cart-drawer__close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Cart icon in header opens drawer (intercept navigation)
  var headerCart = document.querySelector('.site-header__cart');
  if (headerCart) {
    headerCart.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart();
      openDrawer();
    });
  }

  // Qty + remove inside drawer (event delegation)
  drawer.addEventListener('click', async function (e) {
    var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
    var removeBtn = e.target.closest('.cart-drawer__item-remove');
    var btn = qtyBtn || removeBtn;
    if (!btn) return;

    var line = parseInt(btn.dataset.line);
    if (!line) return;

    try {
      var cartRes = await fetch(localeRoot() + 'cart.js');
      if (!cartRes.ok) return;
      var cart = await cartRes.json();
      var item = cart.items[line - 1];
      if (!item) return;

      var newQty = item.quantity;
      if (removeBtn) {
        newQty = 0;
      } else if (qtyBtn.dataset.action === 'plus') {
        newQty = newQty + 1;
      } else if (qtyBtn.dataset.action === 'minus') {
        newQty = Math.max(0, newQty - 1);
      }

      await fetch(localeRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty }),
      });

      await refreshCart();
    } catch (err) {}
  });

  // ESC key closes drawer
  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('cart-drawer--open')) return;
    if (e.key === 'Escape') closeDrawer();
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
